<div class="query-chips-wrapper" data-cy="query-chips-area" [ngClass]="{'query-chips-wrapper-retract' : retractChipsArea}">
  @for (chip of getCurrentFiltersInQuery(); track chip; let index = $index) {
    <div class="query-chip"
      [ngClass]="{'retract' : retractChipsArea}"
      [attr.data-cy]="getDataCy(index)"
      [ngStyle]="{'background-color': getChipBackgroundColor(chip)}">
      <span class="query-chip-text">{{formatCriteriaFilterToDisplay(chip) | JoinArrayStringsPipe | undefinedValue}} :</span>
      <div class="query-chip-text-value-wrapper">
        <app-tooltip [message]="formatCriteriaFilterValueToDisplay(chip)">
          <span class="query-chip-text query-chip-text-value">{{formatCriteriaFilterValueToDisplay(chip) | JoinArrayStringsPipe | undefinedValue}}</span>
        </app-tooltip>
      </div>
      <button (click)="removeChip(chip)"
        class="query-chip-delete-button"
        data-cy="query-chip-delete-button">
        <span class="iwp-icon-gen_close_l"></span>
      </button>
    </div>
  }
</div>
